// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let IconV5 = require("../../../v5/common/Components/IconV5.bs.js");
let ButtonsV5 = require("../../../v5/common/Components/ButtonsV5.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let ReactAriaComponents = require("react-aria-components");

function SearchComponents$MenuItem(props) {
  let __position = props.position;
  let __showIcon = props.showIcon;
  let showIcon = __showIcon !== undefined ? __showIcon : true;
  let position = __position !== undefined ? __position : "Left";
  let match = React.useState(() => false);
  let setIsOpen = match[1];
  let isOpen = match[0];
  let placement;
  placement = position === "Right" ? "bottom end" : "bottom start";
  return JsxRuntime.jsxs(ReactAriaComponents.DialogTrigger, {
    children: [
      JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
        size: "small",
        ariaExpanded: isOpen,
        id: props.id,
        _type: "button",
        children: JsxRuntime.jsxs("span", {
          children: [
            props.title,
            showIcon ? JsxRuntime.jsx("span", {
                children: JsxRuntime.jsx(IconV5.make, {
                  icon: isOpen ? "arrow-up" : "arrow-down",
                  size: 12
                }),
                "aria-hidden": true
              }) : null
          ],
          className: "flex items-center gap-1.5"
        })
      }),
      JsxRuntime.jsx(ReactAriaComponents.Popover, {
        children: JsxRuntime.jsx(ReactAriaComponents.Dialog, {
          children: props.children
        }),
        className: "z-50 w-max max-w-[calc(100vw-2rem)] overflow-y-auto overscroll-contain rounded-md border border-zinc-200 bg-white p-4 shadow-lg outline-none",
        placement: placement
      })
    ],
    isOpen: isOpen,
    onOpenChange: value => setIsOpen(param => value)
  });
}

let MenuItem = {
  make: SearchComponents$MenuItem
};

exports.MenuItem = MenuItem;
/* react Not a pure module */
